import React from 'react';
import './footer.css';

const Footer = () => {
    return (
        <div className="footer">
            <p className="links">
                &nbsp;
                <b>Confluence:</b> <a href="https://confluence.dkcorpit.com/display/doc/Quarterly+Access+Review+%28QAR%29+Forms" 
                            target="_blank">RBAC-Manhattan Help</a>
                &nbsp;|&nbsp;
                <b>Slack:</b> <a href="https://draftkings.slack.com/archives/C03AN79F0RW"
                        target="_blank">#help-manhattan</a>
            </p>
            
        </div>
    )
};

export default Footer;